import React, { useEffect, useState } from 'react';
import axios_instance from '../../../services/auth/jwt/config';
import { Box, Grid, Paper, Typography } from '@material-ui/core';
import { Bar, BarChart, CartesianGrid, Cell, ResponsiveContainer, XAxis, YAxis, Tooltip } from 'recharts';
import MaterialTable from '@material-table/core';
import { tableIcons } from '../../../@jumbo/constants/TableConstants';

type PerguntaGraph = {
    id: number;
    pergunta: string;
    color: string[];
    total: number;
    modo: {
        graph: 'bar' | 'pie' | 'table';
    },
    opcaos: {
        id: number;
        opcao: string;
        filtro_0: number;
        filtro_1: number;
        filtro_2: number;
        filtro_3: number;
    }[],
    respostas?: {
        resposta: string;
    }[]
}

interface PainelPerguntasProps {
    abaFiltro: any;
    periodoGrafico: {
        periodo: string;
        iniDate: Date;
        lastDate: Date;
    };
}

export default function PainelPerguntas({ abaFiltro, periodoGrafico, ...props }: PainelPerguntasProps) {
    const [perguntas, setPerguntas] = useState<PerguntaGraph[]>([])

    useEffect(() => {
        let form = {
            periodo: periodoGrafico.periodo,
            start: periodoGrafico.iniDate,
            end: periodoGrafico.lastDate,
            filtros: abaFiltro,
        };
        axios_instance
            .post<{ success: boolean; data: PerguntaGraph[] }>(
                `ouvidoria/satisfacao/perguntas`,
                form,
            )
            .then(res => {
                let r = res.data;
                if (r.success) {
                    setPerguntas(r.data);
                }
            });
    }, [abaFiltro, periodoGrafico]);
    return <Box>
        <Grid container spacing={2}>
            {perguntas.map((pergunta) => {
                switch (pergunta.modo.graph) {
                    case 'table':
                        return (
                            <Grid item xs={6} key={pergunta.id}>
                                <Paper>
                                    <Box p={2}>
                                        <Typography variant="h6">{pergunta.pergunta} (Total: {pergunta.respostas?.length ?? 0})</Typography>
                                        <MaterialTable
                                            data={pergunta.respostas ?? []}
                                            title="Respostas"
                                            icons={tableIcons}
                                            components={{
                                                Container: props => <div {...props} />
                                            }}
                                            columns={[
                                                { title: 'Resposta', field: 'resposta' },
                                            ]}
                                        />
                                    </Box>
                                </Paper>
                            </Grid>
                        )
                    case 'pie':
                    case 'bar':
                    default:
                        return <Grid item xs={6} key={pergunta.id}>
                            <Paper>
                                <Box p={2}>
                                    <Typography variant="h6">{pergunta.pergunta} (Total: {pergunta.total})</Typography>
                                    <ResponsiveContainer width="100%" height={500}>
                                        <BarChart width={200} height={200} data={pergunta.opcaos} layout="vertical">
                                            <Tooltip />
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis type="number" />
                                            <YAxis dataKey="opcao" type="category" width={200} />
                                            {abaFiltro.map((filtro: any, index: number) => <Bar dataKey={`filtro_${index}`} key={index} name={filtro.nome}>
                                                {pergunta.opcaos.map((entry, index) => (
                                                    <Cell key={`cell-${index}`} fill={pergunta.color[index % pergunta.color.length]} />
                                                ))}
                                            </Bar>)}
                                        </BarChart>
                                    </ResponsiveContainer>
                                </Box>
                            </Paper>
                        </Grid>
                }
            })}
        </Grid>
    </Box>
}